import { useEffect, useRef, useState, useCallback } from "react";
import "./LoadingScreen.css";

const LoadingScreen = ({
  onComplete,
  typingSpeed = 80,
  deletingSpeed = 40,
  pauseDuration = 800,
}) => {
  const [displayedText, setDisplayedText] = useState("");
  const [currentCharIndex, setCurrentCharIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isComplete, setIsComplete] = useState(false);
  const cursorRef = useRef(null);

  const text = "welcome";

  // Cursor blink animation
  useEffect(() => {
    if (!cursorRef.current) return;

    let visible = true;
    const blinkInterval = setInterval(() => {
      visible = !visible;
      if (cursorRef.current) {
        cursorRef.current.style.opacity = visible ? "1" : "0";
      }
    }, 500);

    return () => clearInterval(blinkInterval);
  }, []);

  // Typing animation
  useEffect(() => {
    if (isComplete) return;

    let timeout;

    if (isDeleting) {
      // Deleting phase
      if (displayedText === "") {
        // Done deleting, trigger complete
        setIsComplete(true);
        setTimeout(() => {
          onComplete?.();
        }, 300); // Small delay before showing carousel
      } else {
        timeout = setTimeout(() => {
          setDisplayedText((prev) => prev.slice(0, -1));
        }, deletingSpeed);
      }
    } else {
      // Typing phase
      if (currentCharIndex < text.length) {
        timeout = setTimeout(() => {
          setDisplayedText((prev) => prev + text[currentCharIndex]);
          setCurrentCharIndex((prev) => prev + 1);
        }, typingSpeed);
      } else {
        // Done typing, pause then start deleting
        timeout = setTimeout(() => {
          setIsDeleting(true);
        }, pauseDuration);
      }
    }

    return () => clearTimeout(timeout);
  }, [
    currentCharIndex,
    displayedText,
    isDeleting,
    isComplete,
    typingSpeed,
    deletingSpeed,
    pauseDuration,
    onComplete,
  ]);

  return (
    <div className={`loading-screen ${isComplete ? "is-fading" : ""}`}>
      <div className="loading-screen__content">
        <span className="loading-screen__text">{displayedText}</span>
        <span ref={cursorRef} className="loading-screen__cursor">
          |
        </span>
      </div>
    </div>
  );
};

export default LoadingScreen;
